

































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { RgCategoryFilter, DateRangeFilter, MultiSelect, ArchiveFilter, TagFilter } from '../components/filters';
import { TimeTypes } from '@/config/map.conf';
import * as api from '@/api';
import { getRgUser } from '@/api/rg';

@Component({
    components: {
        RgCategoryFilter,
        DateRangeFilter,
        MultiSelect,
        ArchiveFilter,
        TagFilter
    }
})
export default class TicketRangeSelector extends Vue {
    // 本地状态
    ticketFilter: any = {
        ctiNameList: [],
        archiveIds: [],
        labels: [],
        createdTimeRange: this.getDefaultDateRange(),
        assigned: [],
        state: []
    };

    handlerOptions: { id: string; displayName: string }[] = [];
    ticketCount: number | null = null;
    stateOptions: any;
    summaryLoading: boolean = false;

    created() {
        this.loadOptions();
    }

    /**
     * 获取默认日期范围（最近一个月）
     */
    getDefaultDateRange() {
        const now = new Date();
        const oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());

        return [oneMonthAgo.getTime(), now.getTime()];
    }

    /**
     * 加载筛选选项
     */
    async loadOptions() {
        try {
            this.stateOptions = ['已解决', '已关闭'];
            await this.loadHandlerOptions();
        } catch (error) {
            console.error('加载筛选选项失败', error);
        }
    }

    /**
     * 加载处理人列表
     */
    async loadHandlerOptions() {
        try {
            const res = await getRgUser({
                rgId: this.rgId,
                includeOncall: true
            });

            if (res.code === 200 && res.data && res.data.items) {
                this.handlerOptions = res.data.items.map((user: any) => ({
                    id: user.identify,
                    displayName: user.displayName + ' (' + user.identify + ')'
                }));
            } else {
                this.handlerOptions = [];
            }
        } catch (error) {
            this.handlerOptions = [];
        }
    }

    /**
     * 发送筛选条件变化事件
     */
    async emitChange() {
        this.$emit('filter-change', this.ticketFilter);
    }

    @Watch('ticketFilter', { immediate: true, deep: true })
    async onTicketFilterChange() {
        await this.fetchTicketCount();
    }

    /**
     * 处理 AI 总结按钮点击
     */
    async handleAISummary() {
        this.summaryLoading = true;
        try {
            const filterParams = this.buildFilterParams();

            const res = await api.ticketApi.startAISummaryTask({
                associatedRGs: { assigned: [this.rgId] },
                ...filterParams
            });

            if (res.code === 200) {
                this.$mtd.message({
                    type: 'success',
                    message: 'AI总结任务已提交，请稍候'
                });
                // 发出事件通知父组件刷新列表
                this.$emit('summary-submitted', res.data);
            } else {
                this.$mtd.message({
                    type: 'error',
                    message: 'AI总结提交失败' + res.message
                });
            }
        } catch (error: any) {
            this.$mtd.message({
                type: 'error',
                message: 'AI总结提交失败' + error.message
            });
        } finally {
            this.summaryLoading = false;
        }
    }

    /**
     * 获取工单数量
     */
    async fetchTicketCount() {
        try {
            const filterParams = this.buildFilterParams();
            const res = await api.ticketApi.getTicketCount({
                associatedRGs: { assigned: [this.rgId] },
                ...filterParams
            });
            if (res.code === 200) {
                this.ticketCount = res.data.count || 0;
            }
        } catch (error) {
            console.error('获取工单数量失败', error);
            this.ticketCount = 0;
        }
    }

    /**
     * 构建筛选参数
     * [
        {
            "id": [
                7620,
                8169
            ],
            "namePath": ""
        },
        {
            "id": [
                7620,
                8207,
                8211
            ],
            "namePath": ""
        },
        {
            "id": [
                7620,
                8209
            ],
            "namePath": ""
        }
        ]，提取id数组最后一个
     */
    buildFilterParams() {
        const archiveList = this.ticketFilter.archiveIds?.map(sub => {
            if (sub && sub.id && Array.isArray(sub.id)) {
                return {
                    id: sub.id[sub.id.length - 1],
                    namePath: sub.namePath || ''
                };
            }
            return sub;
        });
        return {
            ctiNameList: this.ticketFilter.ctiNameList,
            labels: this.ticketFilter.labels,
            createdAtStart: this.ticketFilter.createdTimeRange?.[0],
            createdAtEnd: this.ticketFilter.createdTimeRange?.[1],
            assigned: this.ticketFilter.assigned,
            archives: archiveList,
            state: this.ticketFilter.state
        };
    }

    /**
     * 判断是否有活跃的筛选条件
     */
    get hasActiveFilters(): boolean {
        const filter = this.ticketFilter;
        return (
            (filter.ctiNameList && filter.ctiNameList.length > 0) ||
            (filter.archiveIds && filter.archiveIds.length > 0) ||
            (filter.labels && filter.labels.length > 0) ||
            (filter.state && filter.state.length > 0) ||
            (filter.createdTimeRange && filter.createdTimeRange.length > 0) ||
            (filter.assigned && filter.assigned.length > 0)
        );
    }

    /**
     * 获取RG ID
     */
    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
